import React from 'react';
import { Image } from 'antd';
import { HashLink } from 'react-router-hash-link';

export const Logo = () => {
  return (
    <HashLink smooth to="/#home" className="hover:text-black transition">
      <Image
        src="/images/logo.png"
        alt="Rixsus Logo"
        preview={false}
        className="max-h-11 lg:max-h-14 !w-auto"
      />
    </HashLink>
  );
};
